import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  layers: {
    layer1: {
      source: 'mapbox://planetwatchsas.tier_lo_res',
      vectorLayer: 'tiers_lo_res',
      type: 'heatmap',
      visible: false,
      paint: {
        'heatmap-color': 'purple'
      }
    },
    layer2: {
      source: 'mapbox://planetwatchsas.tier_hi_res',
      vectorLayer: 'tiers_hi_res',
      type: 'fill',
      visible: false,
      paint: {
        'fill-color': 'purple'
      }
    },
    layer3: {
      source: 'mapbox://planetwatchsas.coverage_hi_res',
      vectorLayer: 'coverage_hi_res',
      type: 'fill',
      visible: false,
      paint: {
        'fill-color': 'blue'
      }
    }
  }
}

const layersSlice = createSlice({
  name: 'layers',
  initialState: initialState.layers,
  reducers: {
    setLayerVisibility: (state, action) => {
      const { layerId, visible } = action.payload
      Object.keys(state).forEach(key => {
        state[key].visible = key === layerId ? visible : false
      })
    }
  }
})

export const layersInitialState = initialState.layers

export const { setLayerVisibility } = layersSlice.actions
export default layersSlice.reducer
